var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("Выберите страницу из меню слева.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }